import React, { Component } from "react";
import PropTypes from "prop-types";
import { Editor } from "@tinymce/tinymce-react";
import { Placeholder } from "../../ui";
import { v4 as uuidV4 } from "uuid";
import * as settings from "./settings/index";

export default class Wysiwyg extends Component {
  static propTypes = {
    height: PropTypes.number,
    value: PropTypes.string,
    onChange: PropTypes.func,
    loading: PropTypes.bool,
    saving: PropTypes.bool,
    disabled: PropTypes.bool
  };

  render() {
    if (this.props.loading) {
      let styleBox = {
        background: "#fff",
        border: "1px solid #ddd",
        paddingTop: 16,
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: 16
      };

      return (
        <div>
          <div style={{ ...styleBox }}>
            <Placeholder opacity={60} width={50} height={12} />
          </div>
          <div style={{ ...styleBox, borderTopWidth: 0 }}>
            <Placeholder opacity={60} width={90} height={12} />
          </div>
          <div style={{ ...styleBox, borderTopWidth: 0 }}>
            <div style={{ paddingBottom: 24, textAlign: "center" }}>
              <Placeholder opacity={50} width={50} height={24} />
            </div>

            {[90, 80, 70, 90, 80, 50].map(i => {
              return (
                <div
                  key={`placeholder-${uuidV4()}`}
                  style={{ paddingBottom: 8 }}
                >
                  <Placeholder opacity={40} width={i} height={8} />
                </div>
              );
            })}
          </div>
        </div>
      );
    }

    return (
      <div style={{ position: "relative" }}>
        {this.props.saving ? (
          <div
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              background: "rgba(255, 255, 255, 0.8)",
              zIndex: 2
            }}
          ></div>
        ) : null}

        <Editor
          initialValue={this.props.value || ""}
          apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
          disabled={this.props.disabled || false}
          init={{
            height: this.props.height || 500,
            // selector: "textarea",  // change this value according to your html
            plugins: settings.plugins,
            menubar: settings.menubar,
            toolbar: settings.toolbar,
            toolbar_sticky: true,
            //   content_css: '//www.tiny.cloud/css/codepen.min.css',
            // importcss_append: true,
            templates: settings.templates,
            template_cdate_format:
              "[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]",
            template_mdate_format:
              "[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]",
            quickbars_selection_toolbar: settings.quickbars_selection_toolbar,
            toolbar_mode: "sliding",
            contextmenu: settings.contextmenu,
            fontsize_formats: settings.fontsize_formats
          }}
          onChange={this.props.onChange}
        />
      </div>
    );
  }
}
